import { render, staticRenderFns } from "./RelatoriosCombo.vue?vue&type=template&id=0b5727cf"
import script from "./RelatoriosCombo.vue?vue&type=script&lang=js"
export * from "./RelatoriosCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports